import { InputType, loanStatusConstants } from 'config'

export const defaultInputs = (loanGlobalStatus: any): Record<string, InputType> => {
  return {
    pipelineSection: {
      inputType: 'section',
      title: 'Pipeline',
      span: 'full',
    },
    // nonServicingLoanStatus: {
    //   inputType: 'multiselect',
    //   title: 'Origination Pipeline Default View',
    //   options: loanGlobalStatus,
    // },
    servicingLoanStatus: {
      inputType: 'multiselect',
      title: 'Servicing Pipeline Default View',
      options: loanStatusConstants.servicingStatus,
    },
    custom1: {
      inputType: 'custom',
      title: 'Pipeline',
    },
    borrowerLoanStatus: {
      inputType: 'multiselect',
      title: 'Borrower Pipeline Default View',
      options: loanGlobalStatus,
    },
    defaultLoanStatus: {
      inputType: 'select',
      title: 'Default Loan Status after create',
      options: loanGlobalStatus,
      hasDefaultOption: false,
    },
  }
}
